import { withRouter } from 'react-router-dom';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { Button, Container, Header, Segment } from 'semantic-ui-react';
import Auth from '../../stores/Auth';

@withRouter
@inject(root => ({
	auth: root.auth
}))
@observer
export default class Contact extends React.Component {
	props: {
		auth?: Auth,
		history?: History
	};

	render() {
		const { history } = this.props;

		return (
			<Segment basic>
				<Container text textAlign="justified">
					<Header as="h1" textAlign="center">
						Script Approval Management (SAM)
					</Header>
					<Header as="h2" textAlign="center">
						Contact Us
					</Header>

					<div
						style={{
							marginTop: '3em',
							marginBottom: '2em',
							display: 'flex',
							justifyContent: 'center'
						}}
					>
						<p>
							<p>Have a question you would like to ask about “Script Approvals”?</p>
							<p>
								Email ourselves at:{' '}
								<a href="mailto:approvals@pbsauthority.com.au">approvals@pbsauthority.com.au</a>
							</p>
							<p>For urgent approvals (8am to 5pm AEST) call on : (02) 9003 0577</p>
						</p>
					</div>

					<Button
						primary
						floated="right"
						onClick={() => {
							history.push('/app');
						}}
					>
						Back
					</Button>
					<br />
					<br />
				</Container>
			</Segment>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/Contact/index.js